export default __webpack_public_path__ + "static/media/fullscreen-close.6f38de8d.svg";